import { Text, View } from '@react-pdf/renderer';

// Icons
import { PDFLocationIcon } from '@/components/pdf-icons';

// Utils
import { wrapText, renderDateStringToMonthYear, isEmptyValueArray } from '@shared/utils';
import { formatDegreeAndFieldOfStudy } from '@/utils';

// Types
import { FormEducation } from '@shared/types';

// Tokens
import { SECTION_TITLES } from '@/components/template/resume/Default/tokens';

// Styles
import styles from '../../style';
interface EducationSectionProps {
  educations: FormEducation[];
}
const EducationSection = ({
  educations
}: EducationSectionProps) => {
  if (!educations || isEmptyValueArray(educations)) return null;
  return <View style={styles.sectionContainer} data-sentry-element="View" data-sentry-component="EducationSection" data-sentry-source-file="Education.tsx">
      <Text style={styles.sectionTitle} data-sentry-element="Text" data-sentry-source-file="Education.tsx">{SECTION_TITLES.education}</Text>
      <View style={styles.divider} data-sentry-element="View" data-sentry-source-file="Education.tsx" />

      {educations.map(education => {
      const {
        id = '',
        degree = '',
        admission = '',
        graduation = '',
        school = '',
        address = '',
        major = ''
      } = education || {};
      return <View key={`education-${id}`} style={styles.educationSection}>
            <Text style={styles.educationDegree}>
              {wrapText(formatDegreeAndFieldOfStudy(degree, major), {
            trim: true
          })}
            </Text>
            <Text style={styles.educationDate}>
              {renderDateStringToMonthYear(admission || '', graduation || '')}
            </Text>
            <Text style={styles.educationSchool}>
              {wrapText(school, {
            width: 45,
            trim: true
          })}
            </Text>
            {address && <View style={styles.schoolLocationContainer} break>
                <View style={[styles.addressIcon, {
            marginRight: 4
          }]}>
                  <PDFLocationIcon />
                </View>
                <Text style={styles.schoolLocation}>
                  {wrapText(address, {
              width: 95,
              trim: true
            })}
                </Text>
              </View>}
          </View>;
    })}
    </View>;
};
export default EducationSection;